import styled from 'styled-components';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import { IStyledProps } from 'theme/ThemeDefault';

export const StyledAppLogo = styled(SvgIcon)`
  width: calc(100% - 100px);
  margin: 1rem auto;
`;

export const StyledLogo = styled.img`
  margin-bottom: 2rem;
`

export const StyledLogoSubtitleContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const StyledLogoSubtitle = styled.div`
  font-family: ${(props: IStyledProps) => props.theme.fonts.body};
  font-size: 32px;

  line-height: 36.8px;

  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`